<script lang="ts">
  interface Props {
    remaining: number | null | undefined;
    total?: number;
  }

  let { remaining, total = 3 }: Props = $props();
  let isExhausted = $derived((remaining ?? total) <= 0);
</script>

{#if remaining !== null && remaining !== undefined}
  <div class="px-3 py-2 text-body2 text-content-tertiary border-b border-default bg-surface flex items-center gap-2">
    <span class="text-base" aria-hidden="true">🔒</span>
    {#if isExhausted}
      <span class="text-error">답장을 받기 전까지 더 보낼 수 없어요. ({total}/{total} 사용)</span>
    {:else}
      <span>답장 대기 중 — 남은 메시지 <strong>{remaining}</strong>/{total}</span>
    {/if}
  </div>
{/if}
